import { render, staticRenderFns } from "./YearRoles.vue?vue&type=template&id=718f7914&"
import script from "./YearRoles.vue?vue&type=script&lang=js&"
export * from "./YearRoles.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./YearRoles.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports